import { ShieldCheck, Waveform, MagnifyingGlass, ChartBar, Broadcast } from "@phosphor-icons/react";
import SignInButton from "./SignInButton";

export default function Header() {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/85 border-b border-zinc-200"
    >
      <div className="max-w-[1600px] mx-auto flex items-center justify-between py-4 px-6 md:px-12">
        <a href="/" className="flex items-center gap-3">
          <div className="w-9 h-9 bg-black text-white flex items-center justify-center">
            <ShieldCheck weight="fill" className="w-5 h-5" />
          </div>
          <div>
            <div className="font-display text-lg font-semibold text-zinc-950 leading-none">
              True<span className="text-emerald-600">Stream</span>
            </div>
            <div className="font-mono-plex text-[9px] text-zinc-500 mt-0.5">
              MULTI-AGENT VERIFICATION · v1.0
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8 font-mono-plex text-[10px] font-semibold text-zinc-700">
          <a href="/#pipeline" className="hover:text-zinc-950 flex items-center gap-1.5">
            <Waveform weight="duotone" className="w-3.5 h-3.5" />
            HOW IT WORKS
          </a>
          <a href="/#trending" className="hover:text-zinc-950 flex items-center gap-1.5">
            <ChartBar weight="duotone" className="w-3.5 h-3.5" />
            TRENDING
          </a>
          <a href="/#faq" className="hover:text-zinc-950 flex items-center gap-1.5">
            <MagnifyingGlass weight="duotone" className="w-3.5 h-3.5" />
            FAQ
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <span className="hidden sm:inline-flex items-center gap-2">
            <span className="w-2 h-2 bg-emerald-500 rounded-full pulse-dot" />
            <span className="font-mono-plex text-[10px] font-semibold text-zinc-700">
              <Broadcast weight="fill" className="w-3 h-3 inline mr-1 -mt-0.5" />
              LIVE
            </span>
          </span>
          <SignInButton />
        </div>
      </div>
    </header>
  );
}
